import React from 'react'
import { SERVICE_TYPE_PATH } from "../../../../config/paths";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import Content from "../../../layout/Content";
import PropTypes from 'prop-types';
import { breadcrumbsPropTypes, matchPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { useLayoutEffect } from 'react';
import ServiceTypeForm from './ServiceTypeForm';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { clearServiceType, getServiceType, putServiceType } from '../../../../actions/bus/ServiceType';

const EditServiceType = ({
    breadcrumbs,
    dispatchGetServiceType,
    dispatchClearServiceType,
    dispatchPutServiceType,
    match: {
        params: { id: serviceTypeId },
    },
    loading,
    serviceType,
}) => {
    useLayoutEffect(() => {
        dispatchGetServiceType({ serviceTypeId });

        return () => dispatchClearServiceType();
    }, []);

    const onSubmit = (formValues) => {
        const newFormValues = { ...formValues };

        dispatchPutServiceType(serviceTypeId, newFormValues);
    };

    const generateInitialValues = ({
        name,
        description
    }) => {
        return {
            name,
            description
        };
    };

    let content;

    if (loading) content = <Loader />;
    else if (serviceType.isEmpty())
        content = <NoDataResource returnPage={SERVICE_TYPE_PATH} />;
    else
        content = (
            <ServiceTypeForm
                onSubmit={onSubmit}
                initialValues={generateInitialValues(serviceType.toJS())}
            />
        );

    return (
        <Content
            breadcrumbs={breadcrumbs}
            title="Editar Tipo de Servicio"
            subtitle="Editar tipo de servicio"
            content={content}
        />
    );
};

EditServiceType.propTypes = {
    breadcrumbs: breadcrumbsPropTypes.isRequired,
    dispatchClearServiceType: PropTypes.func.isRequired,
    dispatchGetServiceType: PropTypes.func.isRequired,
    dispatchPutServiceType: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    match: matchPropTypes.isRequired,
    serviceType: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditServiceType.defaultProps = {
    loading: false,
};

const mapDispatchToProps = {
    dispatchClearServiceType: clearServiceType,
    dispatchGetServiceType: getServiceType,
    dispatchPutServiceType: putServiceType,
};

const mapStateToProps = (
    { BusUnit },
    {
        match: {
            params: { id },
        },
    },
) => ({
    breadcrumbs: [
        ...BusUnit.UnitHome.get('breadcrumbs'),
        {
            text: 'Tipos de Servicio',
            href: SERVICE_TYPE_PATH,
        },
        {
            text: 'Ver',
            href: `${SERVICE_TYPE_PATH}/${id}`,
        },
        {
            text: 'Editar',
            href: '',
        },
    ],
    serviceType: BusUnit.ServiceType.getIn(['current', 'content']),
    loading: !BusUnit.ServiceType.getIn([
        'current',
        'activity',
    ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditServiceType);
